import { render, staticRenderFns } from "./AppCalendarButton.vue?vue&type=template&id=447f5754&"
import script from "./AppCalendarButton.vue?vue&type=script&lang=js&"
export * from "./AppCalendarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447f5754')) {
      api.createRecord('447f5754', component.options)
    } else {
      api.reload('447f5754', component.options)
    }
    module.hot.accept("./AppCalendarButton.vue?vue&type=template&id=447f5754&", function () {
      api.rerender('447f5754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentCalendar/components/AppCalendarButton/AppCalendarButton.vue"
export default component.exports